import { lazyLoad } from 'utils/lazy';

export const Oracle = lazyLoad(
  () => import('./OraclePage'),
  (module) => module.OraclePage
);
